import EligibleRowMobile from './EligibleRowMobile';
import { IInitialState } from 'src/store/initialState';
import { partsToReturnSel, returnsActions } from 'src/store/modules/returns';
import { IEligibleItem } from 'src/services/returns/typings';
import { connect } from 'react-redux';
import { withI18n } from 'react-i18next';

const mapStateToProps = (state: IInitialState) => ({
  partsToReturn: partsToReturnSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  addItemToReturn: (part: IEligibleItem) => {
    dispatch(returnsActions.addPartToReturnList(part));
  },

  removeItemFromReturn: (id: number) => {
    dispatch(returnsActions.removePartFromReturnList(id));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(EligibleRowMobile));
